import { Pipe, PipeTransform, inject } from '@angular/core';
import { WorkingTimeModel } from '@wilson/interfaces';
import { WorkingTimeModelService } from '@wilson/working-time-model';

@Pipe({
  name: 'countWeeklyHours',
  standalone: false,
})
export class CountWeeklyHoursPipe implements PipeTransform {
  private readonly workingTimeModelService = inject(WorkingTimeModelService);

  transform(weekDays: WorkingTimeModel | undefined): string {
    if (!weekDays) return '0';
    return this.workingTimeModelService.countWeekHoursInDateString(weekDays);
  }
}
